/**
 * Loan Rewards Service
 * Migrated from 3in1cms legacy/loanRewardsApi.ts
 */

import { request } from "../core/request";
import { API_RESPONSE_CODES, OPERATION_IDS } from "./constants";
import type { ILoanRewardsRequest, ILoanRewardsResponse } from "../types/loanRewardsTypes";

/**
 * Fetch loan rewards for customer
 * @param data - Loan rewards request data
 * @returns Loan rewards response
 */
export const loanRewardsApi = async (data: ILoanRewardsRequest): Promise<ILoanRewardsResponse> => {
  try {
    const response = (await request<ILoanRewardsResponse, ILoanRewardsRequest>({
      operationId: OPERATION_IDS.loanRewards,
      requestData: { ...data },
    })) as ILoanRewardsResponse;

    if (response.statusCode !== API_RESPONSE_CODES.STATUS_CODE_7001) {
      throw new Error(JSON.stringify(response));
    }

    return response;
  } catch (error) {
    console.error("Error in loanRewardsApi", error);
    return {} as ILoanRewardsResponse;
  }
};
